<template>
  <div id="app">
    <app-header appTitle="Developer Portal" :branding-image="deptLogo">
      <tabs-nav slot="tabs-nav" :links="navLinks" />
      <mobile-nav slot="mobile-nav" :links="navLinks" />
      <!-- <button slot="right-nav" v-if='!this.$store.getters["auth/isAuthenticated"]' class="button is-primary is-small" style="margin-top: -10%;" @click.prevent="login"><i class="fa fa-solid fa-user" style="margin-right: 3%;"></i> Sign-in</button>
      <button slot="right-nav" v-if='!this.$store.getters["auth/isAuthenticated"]' class="button is-info is-small" style="margin-top: -10%; margin-left: 5px;" @click.prevent="forgotPassword"><i class="fa fa-solid fa-key" style="margin-right: 3%;"></i> Forgot password?</button>
      <a href="/login" slot="right-nav" v-if='this.$store.getters["auth/isAuthenticated"]' class="button is-primary is-small" style="color:white; margin-top: -10%;"><b>{{ this.$store.getters["auth/userInfo"].name }}</b></a>
      <button slot="right-nav" v-if='this.$store.getters["auth/isAuthenticated"]' class="button is-danger is-small" style="margin-top: -10%; margin-left: 2%" @click.prevent="signOut"><i class="fa fa-solid fa-user" style="margin-right: 3%;"></i> Sign-out</button>  -->
    </app-header>
    <main class="container main">
      <router-view />
    </main>
    <app-footer :links="navLinks" />
  </div>
</template>

<script>
import logo from "@/assets/DPD BELL logo_w.png";

export default {
  methods:{
    async login() {
      await this.$store.dispatch("auth/signIn");
    },
    async signOut() {
      await this.$store.dispatch("auth/signOut");
    },
    async forgotPassword() {
      await this.$store.dispatch("auth/forgotPassword");
    },
  },
  created() {
    window.location.replace("https://developer-portal.phdcphila.org/");
  
    this.$store.dispatch("auth/loadTokenFromStorage");
  },
  // before mount prints the user info
  beforeMount() {
    if (this.$store.getters["auth/isAuthenticated"]) {
      console.log("User is authenticated");
    } else {
      console.warn("No user info, not authenticated");
    }
  },
  data() {
    return {
      deptLogo: {
        src: logo,
        alt: "Philadelphia Department of Planning and Development logo",
        width: "190px"
      },
      navLinks: [
        {
          href: "DeveloperChecklist",
          text: "Developer Checklist"
        },
        // {
        //   href: "RentalGuideBook",
        //   text: "Rental Guide Book"
        // },
      ]
    };
},
}
</script>

<style lang="scss">
@import "./assets/scss/main.scss";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#trusted-site {
  display: none;
}
</style>
